import React from "react";
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import { withFormik } from 'formik';
import {displayErrors, withTouchedError, withTouchedErrorClass} from "../../../../common/form-helpers";
import {listResourcesIfNeeded} from "../../../../common/crud-actions";
import {push} from "react-router-redux";
import {setNotification} from "../../actions/notifications-actions";
import * as resource from "../../actions/resources";

class GameForm extends React.Component {

    componentWillMount() {
        this.props.listResourcesIfNeeded(resource.NAMESPACE_GAME, resource.MODEL_GAME_DEFINITION, {});
    }

    render() {
        const { values, touched, errors, dirty, handleChange, handleBlur, handleSubmit, handleReset, isSubmitting } = this.props;
        const definitionSelected = values.game_definition_id !== '';

        const list = this.props.game_definitions.list.filter((definition) => { return Date.parse(definition.end) > new Date() });

        return (
            <form onSubmit={handleSubmit}>
                <div className='card'>
                    <div className='card-body'>

                        <input type="hidden" name='game_definition_id' id='game_definition_id' value={( this.props.game_definitions.list && this.props.game_definitions.list[0] && this.props.game_definitions.list[0].id ) || 0} onChange={() => {}}/>
                        { displayErrors(errors, 'game_definition_id') }

                        <div className='row'>
                            <div className='col-md-6'>
                                {   !values.game.id &&
                                    <div className='form-group'>
                                        <p><strong>Soutěž</strong></p>
                                        <select id="game_definition_id" value={values.game_definition_id}
                                                onChange={handleChange} onBlur={handleBlur}
                                                className={withTouchedErrorClass(errors, touched, 'game_definition_id')}>
                                            <option value=''>Zvolte soutěž</option>
                                            {list.map((definition) => (
                                                <option key={definition.id}
                                                        value={definition.id}>{definition.name}</option>))}
                                        </select>
                                        {displayErrors(errors, 'game_definition_id')}
                                    </div>
                                }
                                <p><strong>Tým</strong></p>
                                <div className='form-group'>
                                    <label>Kapitán</label>
                                    <input id="game.properties.captain" placeholder="" type="text" value={values.game.properties.captain} onChange={handleChange} onBlur={handleBlur} className={withTouchedErrorClass(errors, touched, 'game.properties.captain')} />
                                    { displayErrors(errors, 'game.properties.captain') }
                                </div>
                                <div className='form-group'>
                                    <label>Členové týmu</label>
                                    <input id="game.properties.member_1" placeholder="První člen" type="text" value={values.game.properties.member_1} onChange={handleChange} onBlur={handleBlur} className={withTouchedErrorClass(errors, touched, 'game.properties.member_1')} />
                                    { displayErrors(errors, 'game.properties.member_1') }
                                </div>
                                <div className='form-group'>
                                    <input id="game.properties.member_2" placeholder="Druhý člen" type="text" value={values.game.properties.member_2} onChange={handleChange} onBlur={handleBlur} className={withTouchedErrorClass(errors, touched, 'game.properties.member_2')} />
                                    { displayErrors(errors, 'game.properties.member_2') }
                                </div>
                                <div className='form-group'>
                                    <input id="game.properties.member_3" placeholder="Třetí člen" type="text" value={values.game.properties.member_3} onChange={handleChange} onBlur={handleBlur} className={withTouchedErrorClass(errors, touched, 'game.properties.member_3')} />
                                    { displayErrors(errors, 'game.properties.member_3') }
                                </div>
                                <div className='form-group'>
                                    <input id="game.properties.member_4" placeholder="Čtvrtý člen" type="text" value={values.game.properties.member_4} onChange={handleChange} onBlur={handleBlur} className={withTouchedErrorClass(errors, touched, 'game.properties.member_4')} />
                                    { displayErrors(errors, 'game.properties.member_4') }
                                </div>

                                <div className='form-group'>
                                    <label>Kraj</label>
                                    <select id="game.properties.region" placeholder="" type="text" value={values.game.properties.region} onChange={handleChange} onBlur={handleBlur} className={withTouchedErrorClass(errors, touched, 'game.properties.region')} >
                                        <option value=''>- zvolte kraj -</option>
                                        <option value='praha'>Hlavní město Praha</option>
                                        <option value='stredocesky'>Středočeský kraj</option>
                                        <option value='jihocesky'>Jihočeský kraj</option>
                                        <option value='plzensky'>Plzeňský kraj</option>
                                        <option value='karlovarsky'>Karlovarský kraj</option>
                                        <option value='ustecky'>Ústecký kraj</option>
                                        <option value='liberecky'>Liberecký kraj</option>
                                        <option value='kralovohradecky'>Královéhradecký kraj</option>
                                        <option value='pardubicky'>Pardubický kraj</option>
                                        <option value='vysocina'>Kraj Vysočina</option>
                                        <option value='jihomoravsky'>Jihomoravský kraj</option>
                                        <option value='olomoucky'>Olomoucký kraj</option>
                                        <option value='moravskoslezsky'>Moravskoslezský kraj</option>
                                        <option value='zlinsky'>Zlínský kraj</option>
                                    </select>
                                    { displayErrors(errors, 'game.properties.region') }
                                </div>
                                <div className='form-group'>
                                    <label>Název školy</label>
                                    <input id="game.properties.school" placeholder="" type="text" value={values.game.properties.school} onChange={handleChange} onBlur={handleBlur} className={withTouchedErrorClass(errors, touched, 'game.properties.school')} />
                                    { displayErrors(errors, 'game.properties.school') }
                                </div>
                                <div className='form-group'>
                                    <label>Druh školy</label>
                                    <select id="game.properties.school_kind" placeholder="" type="text"
                                            value={values.game.properties.school_kind} onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={withTouchedErrorClass(errors, touched, 'game.properties.school_kind')}>
                                        <option value=''>- zvolte druh školy -</option>
                                        <option value='zs-1'>Základní škola - 1. stupeň</option>
                                        <option value='zs-2'>Základní škola - 2. stupeň</option>
                                        <option value='ss'>Střední škola</option>
                                        <option value='dd'>Dětský domov</option>
                                        <option value='po'>Partnerská organizace</option>
                                    </select>
                                    {displayErrors(errors, 'game.properties.school_kind')}
                                </div>
                                <div className='form-group'>
                                    <label>Třída</label>
                                    <input id="game.properties.class" placeholder="" type="text" value={values.game.properties.class} onChange={handleChange} onBlur={handleBlur} className={withTouchedErrorClass(errors, touched, 'game.properties.class')} />
                                    { displayErrors(errors, 'game.properties.class') }
                                </div>

                            </div>
                            <div className='col-md-6'>
                                <p><strong>Přihlášení pro studenty</strong></p>
                                <div className='form-group'>
                                    <label>Název týmu</label>
                                    <input id="user.username" placeholder="" type="text" value={values.user.username} onChange={handleChange} onBlur={handleBlur} className={withTouchedErrorClass(errors, touched, 'user.username')} />
                                    { displayErrors(errors, 'user.username') }
                                </div>
                                <div className='form-group'>
                                    <label>Heslo</label>
                                    <input id="user.password" placeholder="" type="password" value={values.user.password} onChange={handleChange} onBlur={handleBlur} className={withTouchedErrorClass(errors, touched, 'user.password')} />
                                    { displayErrors(errors, 'user.password') }
                                </div>
                                <div className='form-group'>
                                    <label>Heslo ješte jednou</label>
                                    <input id="user.password_confirmation" placeholder="" type="password" value={values.user.password_confirmation} onChange={handleChange} onBlur={handleBlur} className={withTouchedErrorClass(errors, touched, 'user.password_confirmation')} />
                                    { displayErrors(errors, 'user.password_confirmation') }
                                </div>
                            </div>
                        </div>
                        <div className='separate-top'>
                            <button type='submit' className='btn btn-primary btn-block' disabled={isSubmitting || !definitionSelected}>Odeslat</button>
                        </div>
                    </div>
                </div>


            </form>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        game: state.game,
        game_definitions: state.game_definitions
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        listResourcesIfNeeded: listResourcesIfNeeded,
        push: push,
        setNotification: setNotification
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(withFormik({
    mapPropsToValues: props => props.instance ? props.instance : { user: { username: '', password: '', password_confirmation: '' }, game: { properties: { } }, game_definition_id: ( props.game_definition_id || '' ) },
    handleSubmit: (values, form) => {
        form.props.handleSubmit(values, form);
    },
    enableReinitialize: true,
    displayName: 'GameForm', // helps with React DevTools
})(GameForm));
